module.exports = __webpack_public_path__ + "img/volume_off.9cd69f7f.svg";